export const cacheStep = Symbol();
//# sourceMappingURL=types.js.map